module.exports = __webpack_public_path__ + "img/background.9d9d8b7c.png";